export default __webpack_public_path__ + "static/media/lion-mr-rasta.7507f59c.jpg";